import { DeepMap } from 'react-hook-form';
import { UpdateScheduleShiftInput } from 'apollo/generated/client-operations';
import { ensureNonUndefinedFields, getAsNumber } from 'utils';
import {
  FormInputTypes,
  getUpdateInputValueFunction,
  GridColSpan,
  TypedFormInputs,
} from 'components/form';
import {
  ScheduleShift,
  JobsiteScheduleShiftFormFields,
} from 'containers/jobsite/tabs/jobsiteSchedules/data/types';

export const getFormInputs =
  (): TypedFormInputs<JobsiteScheduleShiftFormFields> => ({
    startTime: {
      element: FormInputTypes.Field,
      label: 'Start time',
      elementProps: {
        fieldType: 'time',
      },
      layout: [GridColSpan.SpanFull, GridColSpan.SmSpan6],
    },
    duration: {
      element: FormInputTypes.Field,
      label: 'Duration',
      elementProps: {
        fieldType: 'number',
      },
      layout: [GridColSpan.SpanFull, GridColSpan.SmSpan6],
    },
  });

export const getDefaultValues = (
  shift: ScheduleShift,
): JobsiteScheduleShiftFormFields => {
  return {
    startTime: shift.startTime,
    duration: shift.duration,
  };
};

export const getUpdateInput = (
  id: string,
  data: JobsiteScheduleShiftFormFields,
  dirtyFields: DeepMap<JobsiteScheduleShiftFormFields, true>,
): UpdateScheduleShiftInput => {
  const getUpdateInputValue = getUpdateInputValueFunction(data, dirtyFields);

  return ensureNonUndefinedFields<UpdateScheduleShiftInput>({
    id,
    startTime: getUpdateInputValue('startTime'),
    duration: getAsNumber(getUpdateInputValue('duration')),
  });
};
